(function() {
  let isAnimating = false;

  function updateFloatingCart(optimistic = false) {
    const cartElement = document.getElementById('global-floating-cart');
    const countElement = cartElement ? cartElement.querySelector('.floating-cart-count') : null;

    if (!cartElement || !countElement) return;

    // 1. AZONNALI OPTIMISTA FRISSÍTÉS
    if (optimistic === true) {
      isAnimating = true;
      const currentCount = parseInt(countElement.textContent) || 0;
      countElement.textContent = currentCount + 1; 
      
      cartElement.style.display = 'flex';
      cartElement.classList.add('is-visible', 'animate-bounce');
      countElement.classList.add('animate-pop');
      
      // Feloldjuk a zárolást az animáció végén
      setTimeout(() => {
        cartElement.classList.remove('animate-bounce');
        countElement.classList.remove('animate-pop');
        isAnimating = false;
        // Miután lecsengett az animáció, lekérjük a biztos adatot
        syncWithServer();
      }, 600);
    } else if (!isAnimating) {
      // Csak akkor frissítünk szerverről, ha épp nem fut az optimista animáció
      syncWithServer();
    }

    function syncWithServer() {
      fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
        .then(response => response.json())
        .then(cart => {
          // Ha közben elindult egy új animáció, ne írjuk felül a számot
          if (isAnimating) return;

          const newCount = cart.item_count;
          if (newCount > 0) {
            cartElement.style.display = 'flex';
            cartElement.classList.add('is-visible');
            countElement.textContent = newCount;
          } else {
            cartElement.classList.remove('is-visible');
            setTimeout(() => {
              if (!cartElement.classList.contains('is-visible')) {
                cartElement.style.display = 'none';
              }
            }, 300);
          }
        })
        .catch(error => console.error('Hiba:', error));
    }
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeName === 'FLY-TO-CART') {
          updateFloatingCart(true); 
        }
      });
    });
  });

  observer.observe(document.body, { childList: true });

  // A téma saját eseményeinél ne használjunk optimista módot, csak szinkronizáljunk
  document.addEventListener('cart:update', () => updateFloatingCart(false));
  document.addEventListener('theme:cart:update', () => updateFloatingCart(false));
  document.addEventListener('cart:refresh', () => updateFloatingCart(false));

  window.addEventListener('load', () => updateFloatingCart(false));
})();